<sc-flex vertical fitHeight stretchContent class="no-field-space import-costsprice-dialog">
    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="erp.ui.import-costsprice-catalog.title"></sc-dictionary-label>
    </sc-dialog-title>

    <sc-padding>
        <div>
          <form [formGroup]="formGroup">
            <sc-flex >
              <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="erp.entity.price.valid-from"></sc-dictionary-label>
                  </mat-label>
                  <input matInput [matDatepicker]="picker1" formControlName="date_from" required="true" type="date-local">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <sc-content-spacer></sc-content-spacer>
              <mat-form-field appearance="fill" class="date-field">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="erp.entity.price.valid-until"></sc-dictionary-label>
                  </mat-label>
                  <input matInput [matDatepicker]="picker2" formControlName="date_until" type="date-local">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </sc-flex>
            <sc-content-spacer vertical></sc-content-spacer>
            <div>
              <sc-flex >
                <button mat-flat-button (click)="chooseFile()">
                  <sc-dictionary-label dictionaryKey="erp.ui.import-costsprice-catalog.action.choose-file"></sc-dictionary-label>
                </button>
                <input #fileChooser type="file" class="fileupload-field" (change)="onFileSelected($event)" #fileUpload accept=".xlsx">
                <sc-content-spacer></sc-content-spacer>
                <sc-flex-fitting-content>
                  <span>{{costsPriceImportData?.file?.name}}</span>
                </sc-flex-fitting-content>

              </sc-flex>
            </div>
          </form>
        </div>
        <div *ngIf="importRunning">
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-dictionary-label dictionaryKey="erp.ui.import-costsprice-catalog.import-running"></sc-dictionary-label>
          <i class="spinner fa-light fa-spinner fa-spin"></i>
        </div>
        <div class="importErrors" *ngIf="hasImportErrors">
          <sc-content-spacer vertical></sc-content-spacer>
          <div>
            <div>
              <sc-dictionary-label dictionaryKey="erp.ui.import-costsprice-catalog.error.costsprice-period-not-modifiable"></sc-dictionary-label>
          </div>
            <div class="article-error-entry" *ngFor="let identifier of articlesWithNotModifiableCostsPrices">
              {{identifier}}
            </div>
          </div>
        </div>
    </sc-padding>

    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          <sc-dictionary-label dictionaryKey="erp.ui.import-costsprice-catalog.action.cancel"></sc-dictionary-label>
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          <sc-dictionary-label dictionaryKey="erp.ui.import-costsprice-catalog.action.confirm"></sc-dictionary-label>
        </button>
    </sc-actionbar>
</sc-flex>
